import { Fragment, HTMLAttributes, MouseEvent } from 'react';
import { getMergedClassNames } from 'utils/HTMLUtils';

import styles from './HelpButtonEditEscola.scss';
import TooltipCaller from 'components/TooltipManager/TooltipCaller';
import InfoIconEditEscola from 'assets/icons/infoIconEditEscola';
const rootClassName = styles.rootClassName;

interface Props {
  text?: string;
  tooltipCallerClassName?: string;
  className?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  placement?: string;
  style?: HTMLAttributes<HTMLDivElement>['style'];
}
export default function HelpButtonEditEscola(props: Props) {
  return props.text ? (
    <TooltipCaller text={props.text} className={props.tooltipCallerClassName}>
      <div
        style={props.style}
        className={getMergedClassNames([rootClassName, props.className])}
        onClick={props.onClick}
      >
        <InfoIconEditEscola className={rootClassName + '-icon'} />
      </div>
    </TooltipCaller>
  ) : (
    <Fragment />
  );
}
